import {
  GET_AD_GROUP_AD,
  GET_AD_GROUP_AD_SUCCESS,
  GET_AD_GROUP_AD_ERROR,
  CREATE_AD_GROUP_AD,
  CREATE_AD_GROUP_AD_SUCCESS,
  CREATE_AD_GROUP_AD_ERROR,
  UPDATE_AD_GROUP_AD,
  UPDATE_AD_GROUP_AD_SUCCESS,
  UPDATE_AD_GROUP_AD_ERROR,
  DELETE_AD_GROUP_AD,
  DELETE_AD_GROUP_AD_SUCCESS,
  DELETE_AD_GROUP_AD_ERROR
} from "./actionTypes"

export const getAdGroupAd = () => {
  return {
    type: GET_AD_GROUP_AD
  }
}

export const getAdGroupAdSuccess = ad_gorup_ads => {
  return {
    type: GET_AD_GROUP_AD_SUCCESS,
    payload: ad_gorup_ads,
  }
}

export const getAdGroupAdError = error => {
  return {
    type: GET_AD_GROUP_AD_ERROR,
    payload: error,
  }
}

export const createAdGroupAd = (payload) => {
  return {
    type: CREATE_AD_GROUP_AD,
    payload: payload
  }
}

export const createAdGroupAdSuccess = (ad_group_ad) => {
  return {
    type: CREATE_AD_GROUP_AD_SUCCESS,
    payload: ad_group_ad
  }
}

export const createAdGroupAdError = (error) => {
  return {
    type: CREATE_AD_GROUP_AD_ERROR,
    payload: error
  }
}

export const updateAdGroupAd = (payload) => {
  return {
    type: UPDATE_AD_GROUP_AD,
    payload: payload
  }
}

export const updateAdGroupAdSuccess = (ad_group_ad) => {
  return {
    type: UPDATE_AD_GROUP_AD_SUCCESS,
    payload: ad_group_ad
  }
}

export const updateAdGroupAdError = (error) => {
  return {
    type: UPDATE_AD_GROUP_AD_ERROR,
    payload: error
  }
}

export const deleteAdGroupAd = (payload) => {
  return {
    type: DELETE_AD_GROUP_AD,
    payload: payload
  }
}

export const deleteAdGroupAdSuccess = (ad_group_ad) => {
  return {
    type: DELETE_AD_GROUP_AD_SUCCESS,
    payload: ad_group_ad
  }
}

export const deleteAdGroupAdError = (error) => {
  return {
    type: DELETE_AD_GROUP_AD_ERROR,
    payload: error
  }
}